export default "__VITE_ASSET__DzDjJSp9__"